<template>
    <div class="app-nav-top">
        <nav class="flex text-white" style="background-color:rgba(0,0,0,0.5); border-bottom-width:0;">
            <button
                type="button"
                class="btn h-header w-header flex items-center justify-center"
                @click="$emit('cancel')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
                    <path fill="currentColor"
                          d="M19.188 19.188a1 1 0 0 1-1.358.052L10 11.41l-7.83 7.83a1 1 0 0 1-1.41-1.41L8.59 10 .76 2.17A1 1 0 0 1 2.17.76L10 8.59 17.83.76a1 1 0 0 1 1.41 1.41L11.41 10l7.83 7.83a1 1 0 0 1-.052 1.358z" />
                </svg>
            </button>
            <div class="flex flex-1 items-center overflow-x-hidden justify-center">
                <h2 class="truncate" style="margin:0">{{ title }}</h2>
            </div>
            <button
                type="button"
                class="btn h-header w-header flex items-center justify-center"
                @click="$emit('save')">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor"
                          d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
                </svg>
            </button>
        </nav>
        <div class="h-header"></div>
    </div>
</template>

<script>
    export default {

        props: {
            title: {
                type: String,
                required: true,
            },
            showSaveDraft: {
                type: Boolean,
                default: true,
            },
        },

        methods: {},

    };

</script>
